import React, { useState } from "react";
import PropTypes from "prop-types";
import CONSTANTS from "./../../../../common/constants";

import DisplaySwitchBar from "../ActionBars/DisplaySwitchBar";
import Divider from "../../../Common/Divider";
import Details from "./DetailsSection/Details";
import Vehicles from "./VehiclesSection/Vehicles";
import Orders from "./OrdersSection/Orders";
import PreferredDealer from "./PreferredDealerSection/PreferredDealer";

function DisplaySwitcher({ customer }) {
	const [display, setDisplay] = useState(CONSTANTS.CUSTOMERS.DISPLAY.DETAILS);

	return (
		<>
			<DisplaySwitchBar
				setDisplayOrders={() => {
					setDisplay(CONSTANTS.CUSTOMERS.DISPLAY.ORDERS);
				}}
				setDisplayDetails={() => {
					setDisplay(CONSTANTS.CUSTOMERS.DISPLAY.DETAILS);
				}}
				setDisplayDealer={() => {
					setDisplay(CONSTANTS.CUSTOMERS.DISPLAY.PREFERRED_DEALER);
				}}
				setDisplayVehicles={() => {
					setDisplay(CONSTANTS.CUSTOMERS.DISPLAY.VEHICLES);
				}}
			/>
			<Divider />
			{display === CONSTANTS.CUSTOMERS.DISPLAY.ORDERS && <Orders customer={customer} />}
			{display === CONSTANTS.CUSTOMERS.DISPLAY.DETAILS && <Details customer={customer} />}
			{display === CONSTANTS.CUSTOMERS.DISPLAY.VEHICLES && <Vehicles customer={customer} />}
			{display === CONSTANTS.CUSTOMERS.DISPLAY.PREFERRED_DEALER && <PreferredDealer customer={customer} />}
		</>
	);
}

DisplaySwitcher.propTypes = {
	customer: PropTypes.object
};

export default DisplaySwitcher;
